import { apiFetch } from './apiClient';
import type { PriceOverride, UpsertPriceOverridePayload, BulkUpsertPriceOverridePayload } from '@/types/priceOverride';
import type { DiscountSlot } from '@/types/room';

/** Lấy danh sách override cho 1 phòng hoặc loại phòng trong 1 tháng */
export async function getByMonth(params: { roomId?: string; roomType?: string; month: string }): Promise<PriceOverride[]> {
  const query = new URLSearchParams();
  if (params.roomId) query.set('roomId', params.roomId);
  if (params.roomType) query.set('roomType', params.roomType);
  query.set('month', params.month);
  return apiFetch<PriceOverride[]>(`/price-overrides?${query.toString()}`);
}

/** Tạo hoặc cập nhật 1 override */
export async function upsert(data: UpsertPriceOverridePayload): Promise<PriceOverride> {
  return apiFetch<PriceOverride>('/price-overrides', { method: 'POST', body: data });
}

/** Bulk upsert nhiều ngày cùng lúc */
export async function bulkUpsert(data: BulkUpsertPriceOverridePayload): Promise<{ count: number }> {
  return apiFetch<{ count: number }>('/price-overrides/bulk', { method: 'POST', body: data });
}

/** Xóa 1 override */
export async function remove(id: string): Promise<void> {
  await apiFetch<void>(`/price-overrides/${id}`, { method: 'DELETE' });
}

/** Xóa nhiều override */
export async function bulkRemove(ids: string[]): Promise<{ count: number }> {
  return apiFetch<{ count: number }>('/price-overrides/bulk', { method: 'DELETE', body: { ids } });
}

/** Lấy giá hiệu lực cho phòng + ngày (đã merge override) — public endpoint */
export async function resolvePrice(roomId: string, date: string): Promise<ResolvedPrice> {
  return apiFetch<ResolvedPrice>(`/price/resolve?roomId=${roomId}&date=${date}`);
}

export interface ResolvedPrice {
  hourlyRate: number;
  dailyRate: number;
  overnightRate: number;
  extraHourRate: number;
  combo3hRate: number;
  combo6h1hRate: number;
  combo6h1hDiscount: number;
  discountSlots: DiscountSlot[] | null;
  hasOverride: boolean;
}
